import { useEffect, useState } from "react";
import { Link, matchPath, Outlet, useLocation } from "react-router-dom";
import { ConfigProvider, Layout, Menu, MenuProps } from "antd";
import { useMe } from "@/hooks";
import { CalendarAccountCreateModal, CalendarAccountUpdateModal, CalendarCreateModal, CalendarUpdateModal, PpmProjectUpdateModal, ScheduleCreateModal, ScheduleFilesModal, ScheduleUpdateModal } from "@/components";
import { isIthClient } from "@/utils"
import { GlobalContext } from '@/contexts'

const menus = [
  {
    path: '/',
    title: '今天',
    matchPaths: ['/'],
  },
  {
    path: '/projects',
    title: '项目',
    matchPaths: ['/projects', '/projects/:projectID/:tab'],
  },
  {
    path: '/schedules',
    title: '日历',
    matchPaths: ['/schedules'],
  },
  // {
  //   path: '/worktime',
  //   title: '工时审批',
  //   matchPaths: ['/worktime', '/worktime/:id'],
  // },
];

export const BasicLayout = () => {
  const [menuSelectedKeys, setMenuSelectedKeys] = useState<string[]>();
  const location = useLocation();

  const { data: user } = useMe();

  // useWxworkOrgs();
  // useWxworkUsers();

  useEffect(() => {
    const selectedMenu = menus.find(item => item.matchPaths.some(path => matchPath(path, location.pathname)));
    setMenuSelectedKeys(selectedMenu ? [selectedMenu.path] : []);
  }, [location]);

  const menuItems: MenuProps['items'] = menus.map(item => ({
    key: item.path,
    label: (
      <Link to={item.path}>
        {item.title}
      </Link>
    ),
  }));

  return (
    <GlobalContext.Provider value={{ user }}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#1f1547",
          },
          components: {
            Layout: {
              headerBg: '#FFFFFF',
            },
            Button: {
              primaryShadow: 'none'
            },
          },
        }}
      >
        <Layout>
          {isIthClient() && (
            <Layout.Header>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: 'rgb(39, 39, 39)',
                  }
                }}
              >
                <Menu
                  mode="horizontal"
                  items={menuItems}
                  selectedKeys={menuSelectedKeys}
                />
              </ConfigProvider>
            </Layout.Header>
          )}

          <Layout.Content className="p-[25px]" style={{ minHeight: 'calc(100vh - 64px)' }}>
            <Outlet />
          </Layout.Content>
        </Layout>
        <ScheduleCreateModal />
        <ScheduleUpdateModal />
        <ScheduleFilesModal />
        <CalendarCreateModal />
        <CalendarUpdateModal />
        <CalendarAccountCreateModal />
        <CalendarAccountUpdateModal />
        <PpmProjectUpdateModal />
        </ConfigProvider>
    </GlobalContext.Provider>
  );
};
